/* eslint-disable prettier/prettier */
import React, { useState, useEffect, useContext } from 'react';
import { Context } from '../../StoreContext/Context';
import { Formik, Form, Field, ErrorMessage } from 'formik';

import * as Yup from 'yup';
import MaskedInput from 'react-text-mask';

import { useHistory, useParams } from 'react-router-dom';

import Aos from 'aos';
import api from '../../services/api';
import 'aos/dist/aos.css';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const cepMask = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
const phoneNumberMask = [
  '(',
  /[1-9]/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

const optionsUFRG = [
  { id: 'AC', title: 'Acre' },
  { id: 'AL', title: 'Alagoas' },
  { id: 'AP', title: 'Amapa' },
  { id: 'AM', title: 'Amazonas' },
  { id: 'BA', title: 'Bahia' },
  { id: 'CE', title: 'Ceará' },
  { id: 'DF', title: 'Distrito Federal' },
  { id: 'ES', title: 'Espirito Santo' },
  { id: 'GO', title: 'Goiás' },
  { id: 'MA', title: 'Maranhão' },
  { id: 'MT', title: 'Mato Grosso' },
  { id: 'MS', title: 'Mato Grosso do Sul' },
  { id: 'MG', title: 'Minas Gerais' },
  { id: 'PA', title: 'Pará' },
  { id: 'PB', title: 'Paraíba' },
  { id: 'PR', title: 'Paraná' },
  { id: 'PE', title: 'Pernambuco' },
  { id: 'PI', title: 'Piauí' },
  { id: 'RJ', title: 'Rio de Janeiro' },
  { id: 'RN', title: 'Rio Grande do Norte' },
  { id: 'RS', title: 'Rio Grande do Sul' },
  { id: 'RO', title: 'Rondônia' },
  { id: 'RR', title: 'Roraima' },
  { id: 'SC', title: 'Santa Catarina' },
  { id: 'SP', title: 'São Paulo' },
  { id: 'SE', title: 'Sergipe' },
  { id: 'TO', title: 'Tocantins' },
];
const optionsUF = [
  { id: 'AC', title: 'Acre' },
  { id: 'AL', title: 'Alagoas' },
  { id: 'AP', title: 'Amapa' },
  { id: 'AM', title: 'Amazonas' },
  { id: 'BA', title: 'Bahia' },
  { id: 'CE', title: 'Ceará' },
  { id: 'DF', title: 'Distrito Federal' },
  { id: 'ES', title: 'Espirito Santo' },
  { id: 'GO', title: 'Goiás' },
  { id: 'MA', title: 'Maranhão' },
  { id: 'MT', title: 'Mato Grosso' },
  { id: 'MS', title: 'Mato Grosso do Sul' },
  { id: 'MG', title: 'Minas Gerais' },
  { id: 'PA', title: 'Pará' },
  { id: 'PB', title: 'Paraíba' },
  { id: 'PR', title: 'Paraná' },
  { id: 'PE', title: 'Pernambuco' },
  { id: 'PI', title: 'Piauí' },
  { id: 'RJ', title: 'Rio de Janeiro' },
  { id: 'RN', title: 'Rio Grande do Norte' },
  { id: 'RS', title: 'Rio Grande do Sul' },
  { id: 'RO', title: 'Rondônia' },
  { id: 'RR', title: 'Roraima' },
  { id: 'SC', title: 'Santa Catarina' },
  { id: 'SP', title: 'São Paulo' },
  { id: 'SE', title: 'Sergipe' },
  { id: 'TO', title: 'Tocantins' },
];

const optionsUFCRM = [
  { id: 'AC', title: 'Acre' },
  { id: 'AL', title: 'Alagoas' },
  { id: 'AP', title: 'Amapa' },
  { id: 'AM', title: 'Amazonas' },
  { id: 'BA', title: 'Bahia' },
  { id: 'CE', title: 'Ceará' },
  { id: 'DF', title: 'Distrito Federal' },
  { id: 'ES', title: 'Espirito Santo' },
  { id: 'GO', title: 'Goiás' },
  { id: 'MA', title: 'Maranhão' },
  { id: 'MT', title: 'Mato Grosso' },
  { id: 'MS', title: 'Mato Grosso do Sul' },
  { id: 'MG', title: 'Minas Gerais' },
  { id: 'PA', title: 'Pará' },
  { id: 'PB', title: 'Paraíba' },
  { id: 'PR', title: 'Paraná' },
  { id: 'PE', title: 'Pernambuco' },
  { id: 'PI', title: 'Piauí' },
  { id: 'RJ', title: 'Rio de Janeiro' },
  { id: 'RN', title: 'Rio Grande do Norte' },
  { id: 'RS', title: 'Rio Grande do Sul' },
  { id: 'RO', title: 'Rondônia' },
  { id: 'RR', title: 'Roraima' },
  { id: 'SC', title: 'Santa Catarina' },
  { id: 'SP', title: 'São Paulo' },
  { id: 'SE', title: 'Sergipe' },
  { id: 'TO', title: 'Tocantins' },
];

const typeProf =[
  // { title: 'Cuidador'},
  // { title: 'Profissional da Saúde'},
  // { title: 'Paciente'},

  { title: 'Tenho fibrose cística'},
  { title: 'Sou familiar de uma pessoa com fibrose cística'},
  { title: 'Faço parte de uma associação de assistência'},
  { title: 'Sou estudante e tenho interesse no tema'},
  { title: 'Sou profissional da saúde e tenho interesse no tema'},
  { title: 'Outro'},
]

// const typeDoc = [
//   //   { title: 'COFFITO' },
//   { title: 'COREN' },
//   //   { title: 'CRB' },
//   //   { title: 'CREFITO' },
//   { title: 'CRF' },
//   { title: 'CRM' },
//   //   { title: 'OUTROS' },
// ];

const RegisterSchema = Yup.object().shape({
  name: Yup.string()
    .max(30, 'o nome deve ter 30 caracteres no máximo')
    .required('Nome é obrigatório '),

  email: Yup.string()
    .required('E-mail é obrigatório')
    .email('Formato de endereço de e-mail inválido')
    .test(
      'isLowerCase',
      'Email deve ser todo minúsculo',
      (email) => email && email === email.toLowerCase()
    ),

  // password: Yup.string()
  //      .required("Senha é obrigatório")
  //      .matches( /^(?=.*[A-Za-z])(?=.*\d)[\w\W]{8,100}$/,"Digite uma senha forte. Ex: Nbb_885522")
  //      .min(8)
  //      .matches(RegExp("(.*[a-z].*)"), "Lowercase")
  //      .matches(RegExp("(.*[A-Z].*)"), "Uppercase")
  //      .matches(RegExp("(.*\\d.*)"), "Number"),

  fields: Yup.object().shape({
    // specialty: Yup.string().required('Campo é obrigatório'),

    // street: Yup.string().required('Rua obrigatório'),

    // district: Yup.string().required('Bairro obrigatório'),

    // homenumber: Yup.number().required('Numero obrigatório'),

    // zipcode: Yup.string().required('CEP obrigatório'),

    // contact: Yup.string().required('Celular obrigatório'),

    // typedoc: Yup.string().oneOf(typeDoc.map((opt) => opt.title),'Seleção inválida').required('Tipo de documento Obrigatório'),

    // crm: Yup.string().required('CRM obrigatório'),

    /*CASO TENHA APENAS CRM*/
    // crm: Yup.string()
    //   .required('CRM obrigatório')
    //   .test('validarCrm', 'CRM invalido', async (value, { parent }) => {
    //     try {
    //       if (!value) return false;
    //       const response = await fetch(
    //         `https://rstcom.live/wserver/api/crm_data/${value}/${parent.state_crm}`
    //       );
    //       const { error } = await response.json();

    //       return !error;
    //     } catch (error) {
    //       return false;
    //     }
    //   }),

    state: Yup.string()
      .oneOf(
        optionsUF.map((opt) => opt.id),
        'Seleção inválida'
      )
      .required('Estado Obrigatório'),

    city: Yup.string().required('Cidade é obrigatório'),

    TypeProf: Yup.string().required('Campo obrigatório'),

    // state_crm: Yup.string().oneOf(optionsUFCRM.map((opt) => opt.id),'Seleção inválida').required('CRM do Estado é Obrigatório'),

    // rg: Yup.string().required('RG obrigatório'),

    // state_rg: Yup.string()
    //   .oneOf(
    //     optionsUFRG.map((opt) => opt.id),
    //     'Seleção inválida'
    //   )
    //   .required('RG do Estado é Obrigatório'),

    // orgao_expedidor: Yup.string().required('Órgão expedidor RG Obrigatório'),

    // cpf: Yup.string().required('CPF obrigatório'),

    acceptTerms: Yup.bool().oneOf([true], 'Precisa assinar os termos'),
    acceptRecord: Yup.bool().oneOf([true], 'Precisa assinar os termos'),
  }),
});

const SectionRegister = () => {
  const { inforRegister } = useContext(Context);

  const history = useHistory();
  const { eventKey } = useParams();
  const [isSubmitting, SetisSubmitting] = useState(false);

  const [initialValues, SetInitialValues] = useState({
    name: '',
    email: '',
    role: 'participante',
    fields: {
      // zipcode: '',
      // street: '',
      // district: '',
      // complement: '',
      // homenumber: '',
      // sizeshirt: '',

      // contact: '',
      city: '',
      state: '',
      TypeProf: '',
      // specialty: '',

      typedoc: '',
      // crm: '',
      // state_crm: '',
      // rg: '',
      // state_rg: '',
      orgao_expedidor: '',

      // cpf: '',
      acceptTerms: false,
      acceptRecord: false,
    },
    eventKey: '',
    password: '',
  });

  const handleSubmit = async (values, actions) => {
    if (isSubmitting) return;
    SetisSubmitting(true);
    try {
      console.log('handleSubmit', values);

      await api.post('participant', values);

      // Envio do email
    //   const obj2 = {
    //     subject: 'TORRENT CONVENÇÃO DIGITAL',
    //     to: 'noreply@torrent.com.br',
    //     from: 'noreply@torrent.com.br',
    //     fromname: 'Confirmação de Inscrição TORRENT CONVENÇÃO DIGITAL',
    //     urlmail: `https://4yourlive.com/${values.eventKey}/email/index.html`,
    //     name: values.name,
    //     email: values.email,
    //   };

    //   let formBody = [];

    //   for (const property in obj2) {
    //     const encodedKey = encodeURIComponent(property);
    //     const encodedValue = encodeURIComponent(obj2[property]);
    //     formBody.push(`${encodedKey}=${encodedValue}`);
    //   }
    //   formBody = formBody.join('&');

      // fetch('https://rstcom.live/mailgun-sendmail/index.php', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      //   },
      //   body: formBody,
      // }).then(
      //   (response) => {
      //     console.log('SUCCESS!', response.status, response.text);
      //   },
      //   (error) => {
      //     console.log('FAILED...', error);
      //   }
      // );

      toast.success(
        'Dados Cadastrado com Sucesso!', {
         position: "bottom-right",
         autoClose: 3000,
         hideProgressBar: false,
         closeOnClick: true,
         pauseOnHover: true,
         draggable: true,
         progress: undefined,
         });

      actions.resetForm();
      history.push(`/${eventKey}`);
      // window.open(`/${eventKey}/signin`, '_blank');
    } catch (error) {
      toast.error(error?.response?.data?.message ||
        'Nao foi possivel realizar o cadastro, tente novamente.', {
         position: "bottom-right",
         autoClose: 3000,
         hideProgressBar: false,
         closeOnClick: true,
         pauseOnHover: true,
         draggable: true,
         progress: undefined,
      });

    } finally {
      SetisSubmitting(false);
    }

    actions.setSubmitting(false);
  };

  function onBlurCep(ev, setFieldValue) {
    const { value } = ev.target;

    const zipcode = value;

    // if (zipcode?.length !== 8) {
    //   return;
    // }

    fetch(`https://viacep.com.br/ws/${zipcode}/json/`)
      .then((res) => res.json())
      .then((data) => {
        setFieldValue('fields[street]', data.logradouro);
        setFieldValue('fields[district]', data.bairro);
        setFieldValue('fields[city]', data.localidade);
        setFieldValue('fields[state]', data.uf);
      });
  }

  useEffect(() => {
    SetInitialValues((prev) => ({ ...prev, password:inforRegister?.settings?.password, eventKey }));
  }, [inforRegister, eventKey]);


  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <>
      {inforRegister?.settings?.access?.show_signup_button && (
        <section id="section-register" className="dark-mode">
          <div className="wm wm-border dark" data-aos="fade-down">
            inscrição
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-6 offset-md-3 text-center">
                <h1 data-aos="fade-up">Inscreva-se</h1>
                <div className="separator">
                  <span>
                    <i className="fa fa-square" />
                  </span>
                </div>
                <div className="spacer-single" />
              </div>
              <div className="col-md-8 offset-md-2" data-aos="fade-up">
                <Formik
                  name="contactForm"
                  id="contact_form"
                  initialValues={initialValues}
                  enableReinitialize
                  validationSchema={RegisterSchema}
                  onSubmit={handleSubmit}
                >
                  {({ handleChange, handleBlur, values, touched, errors }) => (
                    <Form>
                      <div className="row">
                        <div className="col-md-6 mb-0">
                          <div className="">
                            <input
                              type="hidden"
                              name="eventKey"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.eventKey}
                            />
                            <input
                              type="hidden"
                              name="password"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.password}
                            />
                          </div>

                          <div className="form-group">
                            <Field
                              name="fields[TypeProf]"
                              component="select"
                              className={` form-control ${
                                touched?.fields?.TypeProf && errors?.fields?.TypeProf
                                  ? 'is-invalid'
                                  : ''
                              }`}
                            >
                              <option value="">Selecione uma Opção:</option>
                              {typeProf.map((option) => (
                                <option value={option.id} key={option.id}>
                                  {option.title}
                                </option>
                              ))}
                            </Field>

                            <ErrorMessage
                              component="div"
                              name="fields[TypeProf]"
                              className="invalid-feedback"
                            />
                          </div>

                          <div className="form-group">
                            <Field
                              type="text"
                              name="name"
                              placeholder="Nome Completo*"
                              className={`form-control ${
                                touched.name && errors.name ? 'is-invalid' : ''
                              }`}
                            />

                            <ErrorMessage
                              component="div"
                              name="name"
                              className="invalid-feedback"
                            />
                          </div>

                          <div className="form-group">
                            <Field
                              type="text"
                              name="email"
                              placeholder="Email*"
                              className={`form-control ${
                                touched.email && errors.email
                                  ? 'is-invalid'
                                  : ''
                              }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="email"
                              className="invalid-feedback"
                            />
                          </div>

                          {/* <div className="form-group">
                            <Field
                              render={({ field }) => (
                                <MaskedInput
                                  {...field}
                                  mask={phoneNumberMask}
                                  id="phone"
                                  placeholder="Telefone com DDD*"
                                  type="text"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  className={`form-control ${
                                    touched?.fields?.contact &&
                                    errors?.fields?.contact
                                      ? 'is-invalid'
                                      : ''
                                  }`}
                                />
                              )}
                              type="text"
                              name="fields[contact]"
                            />
                            <ErrorMessage
                              component="div"
                              name="fields[contact]"
                              className="invalid-feedback"
                            />
                          </div> */}

                          <div className="form-group">
                            <Field
                              type="text"
                              name="fields[city]"
                              placeholder="Cidade *"
                              className={`form-control ${
                                touched?.fields?.city && errors?.fields?.city
                                  ? 'is-invalid'
                                  : ''
                              }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="fields[city]"
                              className="invalid-feedback"
                            />
                          </div>

                          <div className="form-group">
                            <Field
                              name="fields[state]"
                              component="select"
                              className={` form-control ${
                                touched?.fields?.state && errors?.fields?.state
                                  ? 'is-invalid'
                                  : ''
                              }`}
                            >
                              <option value="">Estado*</option>
                              {optionsUF.map((option) => (
                                <option value={option.id} key={option.id}>
                                  {option.title}
                                </option>
                              ))}
                            </Field>

                            <ErrorMessage
                              component="div"
                              name="fields[state]"
                              className="invalid-feedback"
                            />
                          </div>

                       
{/* 
                          <div className="form-group">
                            <Field
                              type="text"
                              name="fields[specialty]"
                              placeholder="Especialidade *"
                              className={`form-control ${
                                touched?.fields?.specialty &&
                                errors?.fields?.specialty
                                  ? 'is-invalid'
                                  : ''
                              }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="fields[specialty]"
                              className="invalid-feedback"
                            />
                          </div> */}
                        </div>

                        <div className="col-md-6">
                          {/* <div className="form-group">
                            <Field
                              name="fields[typedoc]"
                              component="select"
                              className={` form-control ${
                                touched?.fields?.typedoc &&
                                errors?.fields?.typedoc
                                  ? 'is-invalid'
                                  : ''
                              }`}
                            >
                              <option value="">
                                Selecione o tipo de conselho*
                              </option>
                              {typeDoc.map((option) => (
                                <option value={option.title} key={option.title}>
                                  {option.title}
                                </option>
                              ))}
                            </Field>

                            <ErrorMessage
                              component="div"
                              name="fields[typedoc]"
                              className="invalid-feedback"
                            />
                          </div> */}

                          {/* <div className="form-group">
                            <Field
                              type="number"
                              name="fields[crm]"
                              placeholder="Numero do Conselho *"
                              className={`form-control ${
                                touched?.fields?.crm && errors?.fields?.crm
                                  ? 'is-invalid'
                                  : ''
                              }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="fields[crm]"
                              className="invalid-feedback"
                            />
                          </div> */}

                          {/* <div className="form-group">
                            <Field
                              name="fields[state_crm]"
                              component="select"
                              placeholder="UF Estado *"
                              className={` form-control ${
                                touched?.fields?.state_crm &&
                                errors?.fields?.state_crm
                                  ? 'is-invalid'
                                  : ''
                              }`}
                            >
                              <option value="">UF do Conselho *</option>
                              {optionsUFCRM.map((option) => (
                                <option value={option.id} key={option.id}>
                                  {option.title}
                                </option>
                              ))}
                            </Field>

                            <ErrorMessage
                              component="div"
                              name="fields[state_crm]"
                              className="invalid-feedback"
                            />
                          </div> */}

                          {/* <div className="form-group">
                            <Field
                              type="number"
                              name="fields[rg]"
                              placeholder="Numero do RG *"
                              className={`form-control ${
                                touched?.fields?.rg && errors?.fields?.rg
                                  ? 'is-invalid'
                                  : ''
                              }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="fields[rg]"
                              className="invalid-feedback"
                            />
                          </div> */}

                          {/* <div className="form-group">
                            <Field
                              name="fields[state_rg]"
                              component="select"
                              placeholder="UF Estado *"
                              className={` form-control ${
                                touched?.fields?.state_rg &&
                                errors?.fields?.state_rg
                                  ? 'is-invalid'
                                  : ''
                              }`}
                            >
                              <option value="">UF do RG *</option>
                              {optionsUFRG.map((option) => (
                                <option value={option.id} key={option.id}>
                                  {option.title}
                                </option>
                              ))}
                            </Field>

                            <ErrorMessage
                              component="div"
                              name="fields[state_rg]"
                              className="invalid-feedback"
                            />
                          </div> */}

                          {/* <div className="form-group">
                            <Field
                              type="text"
                              name="fields[orgao_expedidor]"
                              placeholder="Órgão expedidor RG *"
                              className={`form-control ${
                                touched?.fields?.orgao_expedidor &&
                                errors?.fields?.orgao_expedidor
                                  ? 'is-invalid'
                                  : ''
                              }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="fields[orgao_expedidor]"
                              className="invalid-feedback"
                            />
                          </div> */}

                          {/* <div className="form-group">
                            <Field
                              type="number"
                              name="fields[cpf]"
                              placeholder="CPF*"
                              className={`form-control ${
                                touched?.fields?.cpf && errors?.fields?.cpf
                                  ? 'is-invalid'
                                  : ''
                              }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="fields[cpf]"
                              className="invalid-feedback"
                            />
                          </div> */}
                        </div>
                      </div>

                      <div className="form-group form-check">
                        <Field
                          type="checkbox"
                          name="fields[acceptTerms]"
                          id="acceptTerms"
                          className={`form-check-input ${
                            errors?.fields?.acceptTerms &&
                            touched?.fields?.acceptTerms
                              ? ' is-invalid'
                              : ''
                          }`}
                        />

                        <label
                          htmlFor="acceptTerms"
                          className="form-check-label"
                        >
                          Declaro que li e concordo com a{' '}
                          <a
                            href="https://4yourlive.com/rodandobrasil2022/privacy-and-policy"
                            target="_blank"
                            className="termos"
                          >
                            Política de Privacidade
                          </a>
                        </label>
                        <ErrorMessage
                          name="fields[acceptTerms]"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>

                      <div className="form-group form-check">
                        <Field
                          type="checkbox"
                          name="fields[acceptRecord]"
                          id="acceptRecord"
                          className={`form-check-input ${
                            errors?.fields?.acceptRecord &&
                            touched?.fields?.acceptRecord
                              ? ' is-invalid'
                              : ''
                          }`}
                        />

                        <label
                          htmlFor="acceptRecord"
                          className="form-check-label"
                        >
                          Declaro que li e concordo com os{' '}
                          <a
                            href="https://4yourlive.com/rodandobrasil2022/terms-of-use"
                            target="_blank"
                            className="termos"
                          >
                            Termos e Condições de Uso
                          </a>
                        </label>
                        <ErrorMessage
                          name="fields[acceptRecord]"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>

                      <div className="row">
                        <div className="col-md-12 text-center">
                          <button
                            data-aos="fade-up"
                            type="submit"
                            className="btn btn-line"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? 'Cadastrando..' : 'Inscrever-se'}
                          </button>
                        </div>



                        {inforRegister?.settings?.access
                        ?.show_subscribed_button && (
                          <a
                            href={"https://4yourlive.com/rodandobrasil2022/signin"}
                            target="_blank"
                            className="inscrito"
                            data-aos="fade-up"
                          >
                            Já sou inscrito
                          </a>
                        )}

                          <a
                            href={`/${eventKey}/signin`}
                            target="_blank"
                            className="inscrito"
                            data-aos="fade-up"
                          >
                           Acesse ao Evento
                          </a>

                        <ToastContainer />
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default SectionRegister;
